<template>
<div id="sum-col" role="complementary" class="w-25 position-fixed" :class="{'set-margin-top': getButtonCount()}" aria-labelledby="quoteSummary">
  <transition name="slide-fade">
  <div v-show="$store.getters.getQuoteSummaryStatus" id="sum-content" class="w-100 shadow-sm qrp-bg-lightgray  pb-3">
    <!--Removed: 'viewport-bounded' class to remove ;'sticky bottom' function-->
    <div class="row no-gutters position-relative quote-summary-row">
      <!--HEADER-->
      <div id="quoteSummary" class="col-12 py-2 pl-3 float-left bg-black active text-white smaller-font-content">
        <strong>Quote Summary</strong>
      </div>

      <!--QUOTE ID-->
      <div class="w-100 py-2 px-3 smaller-font-content">
        <div class="row mx-0">
          <div class="pl-0 pr-2 font-weight-bold">Quote ID:</div>
          <div class="col px-0">{{getSessionId}}</div>
        </div>
      </div>
      <!--QUOTE ID-->

      <div v-for="(qData, qKey) in quoteData" :key="qKey" class="w-100">
        <!--SECTION HEAD-->
        <div class="col-12 py-1 pl-3 float-left active shadow-sm text-white smaller-font-content bg-black">
          <strong>{{ qData.label }}</strong>
        </div>
        <!--SECTION HEAD-->

        <!--SECTION BODY-->
        <div class="col px-3 accordPanel">
          <div class="py-1 smaller-font-content" v-for="(rData, rKey) in qData.content" :key="rKey">
            <!--Details-->
            <div v-for="(qteData, qteKey) in rData.fields" :key="qteKey" class="row mx-0 mb-1 sum-row">
              <!--Detail Head-->
              <div class="col-12 col-xl-4 pl-0 pr-2 font-weight-bold">{{qteData.label}}</div>
              <!--Detail Content-->
              <div class="col px-0 sum-data">{{qteData.field_value}}</div>
            </div>
            <!--Details-->
            <!--Multiple Detail Divider-->
            <div v-if="rKey != (qData.content.length -1)" class="border-bottom"></div>
            <!--Multiple Detail Divider-->
          </div>
        </div>
      </div>
    </div>
  </div>
  </transition>
</div>
</template>

<script>
/* eslint-disable */

/**
 * This is the QuoteSummary component that is visible on all Interview Pages.
 * This component is a child of the Interview.vue component.
 * A 'summarized' version of ALL the info inputted on the interview pages will be displayed.
 */
export default {
  data() {
    return {
    };
  },
  computed: {
    // retrieve the contents of the Quote Summary widget from the Vuex data store
    quoteData() {
      return this.$store.state.buttonState.quoteSummaryData ? this.$store.state.buttonState.quoteSummaryData.quote_summary_sections : '';
    },
    getSessionId() {
      return this.$store.getters.getSessionID;
    },
  },
  methods: {
    getButtonCount() {
      if (this.$store.state.buttonState && this.$store.state.buttonState.buttonsData && this.$store.state.buttonState.buttonsData.length > 6) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style scoped>
/* always present */
.quote-summary-btn-sec .btn {
  text-transform: none !important;
}
.quote-summary-btn-sec {
 margin-bottom: 85px; 
}
.slide-fade-enter-active {
  transition: all .5s ease;
}
.slide-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(500px);
}
#sum-col {
  top: 48px;
  right: 0px;
  z-index: 1050;
}

/***Navigation Breakpoints***/
@media all and (max-width: 873px) {
  .set-margin-top {
    top: 97px !important;
  }
}
@media all and (min-width: 1371px) {
  .set-margin-top {
    top: 82px;
  }
}
#sum-content {
  right: 0px;
  overflow: hidden;
  height:  100vh;
  .quote-summary-row {
    margin-bottom: 80px;
  }
}
  /***Display Scrollbar onHover***/
  #sum-content:hover {
    overflow-y: scroll;
  }

/***Do Not Shift Content onHover***/
#sum-content .sum-row {
  padding-right: 16px;
}
  #sum-content:hover .sum-row {
    padding-right: 0px !important;
  }

.sum-data{
  word-break: break-word;
  white-space: pre-wrap;
}

/*** ACCORDION CSS ***/
.accordPanel {
    transition: max-height 0.2s ease-out;
    overflow: hidden;
}

.arrow::after {
   content: "	\25bc";
}
.arrow.expanded::after {
    content:  '\25b2';
}
/* Do NOT take out the below #quoteSum_* styling or we can't get height of div immediately after changing because accordion transition effects take too long */
#quoteSum_0,
#quoteSum_1,
#quoteSum_2,
#quoteSum_3,
#quoteSum_4,
#quoteSum_5 {
/*  -webkit-transition-property: -webkit-transform; */
  -webkit-transition: -webkit-transform 1s;
}
/* Do NOT take out the above #quoteSum_* styling or we can't get height of div immediately after changing because accordion transition effects take too long */
</style>



// WEBPACK FOOTER //
// src/components/interview/shared/QuoteSummary.vue?44853a81